import { PreviewItem } from "./preview-item";
import { Site } from "./site";

export class PreviewContext {
    items: Map<string, string> = new Map<string, string>();

    constructor(site: Site, model: Record<string, any>, items?: PreviewItem[]) {

        if (items?.length) {
            const previewUrl = site?.data?.previewUrl;
            for (const item of items) {
                if (item.name?.length && item.path?.length) {
                    const path = item.path.startsWith('http')
                        ? item.path
                        : previewUrl?.length
                            ? `${previewUrl}/${item.path}`
                            : item.path;
                    this.items.set(item.name, this.replaceParameters(path, model));
                }
            }
        }
    }

    private replaceParameters(template: string, model: Record<string, any>): string {
        return template.replace(/\{\{([^{}]+)\}\}/g, (_, name) => {
            const key = name.trim();
            return model[key] ?? '';
        });
    }
}
